// extracted by mini-css-extract-plugin
export default {"nameProfile":"oV5qsWZw","nameText":"whH6uuFc","wrapperAvatar":"YQBPiVui","desktop":"desktop","outlined":"Laavk6i6"};